import { Routes, Route, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Errors/404";
import HostPagesRouter from "navigation/routers/HostPagesRouter";
import MainRouter from "navigation/routers/MainRouter";
import { store } from "application/store";
import { Provider } from "react-redux";
import { ToastContainer } from 'react-toastify';
import moment from "moment";
import 'react-toastify/dist/ReactToastify.css';
import ClientPagesRouter from "navigation/routers/ClientPagesRouter";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import PostHogPageView from "analytics/PostHogPageView";

let persistor = persistStore(store);

const BaseRouter = () => {

  moment.locale(window.navigator.language);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer
          position="bottom-right"
        />
        <BrowserRouter>
          <ScrollToTop />
          <PostHogPageView />
          <Routes>
            <Route path="/host/*" element={<HostPagesRouter />} />
            <Route path="/client/*" element={<ClientPagesRouter />} />
            <Route path="*" element={<MainRouter />} />
            <Route element={<Page404 />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default BaseRouter;
